var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section-brake-nav"},[_c('div',{staticClass:"container-base"},[_c('p',[_vm._v("Lo quiero")]),_c('p',[_vm._v("y con "),_c('span',[_vm._v("Quac")])]),_c('p',[_vm._v("¡Lo tengo!")]),_c('p',{staticClass:"view-movil"},[_vm._v("Lo quiero y con "),_c('span',[_vm._v("Quac")]),_vm._v(" ¡Lo tengo!")])])])
}]

export { render, staticRenderFns }